module.exports = __webpack_public_path__ + "icomoon.5674c.eot";


//////////////////
// WEBPACK FOOTER
// ./app/fonts/spinnaker/fonts/icomoon.eot?jeuj5q
// module id = 2749
// module chunks = 0